export default __webpack_public_path__ + "static/media/Houzz.e425b0cf.svg";